/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { ParamDefinition as PD } from '../../mol-util/param-definition.js';
import { ShrakeRupleyComputationParams, AccessibleSurfaceArea } from './accessible-surface-area/shrake-rupley.js';
import { Unit } from '../../mol-model/structure.js';
import { CustomStructureProperty } from '../common/custom-structure-property.js';
import { QuerySymbolRuntime } from '../../mol-script/runtime/query/compiler.js';
import { CustomPropSymbol } from '../../mol-script/language/symbol.js';
import { Type } from '../../mol-script/language/type.js';
import { CustomPropertyDescriptor } from '../../mol-model/custom-property.js';
export const AccessibleSurfaceAreaParams = {
    ...ShrakeRupleyComputationParams
};
export const AccessibleSurfaceAreaSymbols = {
    isBuried: QuerySymbolRuntime.Dynamic(CustomPropSymbol('computed', 'accessible-surface-area.is-buried', Type.Bool), ctx => {
        if (!Unit.isAtomic(ctx.element.unit))
            return false;
        const accessibleSurfaceArea = AccessibleSurfaceAreaProvider.get(ctx.element.structure).value;
        if (!accessibleSurfaceArea)
            return false;
        return AccessibleSurfaceArea.getFlag(ctx.element, accessibleSurfaceArea) === AccessibleSurfaceArea.Flags.Buried;
    }),
    isAccessible: QuerySymbolRuntime.Dynamic(CustomPropSymbol('computed', 'accessible-surface-area.is-accessible', Type.Bool), ctx => {
        if (!Unit.isAtomic(ctx.element.unit))
            return false;
        const accessibleSurfaceArea = AccessibleSurfaceAreaProvider.get(ctx.element.structure).value;
        if (!accessibleSurfaceArea)
            return false;
        return AccessibleSurfaceArea.getFlag(ctx.element, accessibleSurfaceArea) === AccessibleSurfaceArea.Flags.Accessible;
    }),
};
export const AccessibleSurfaceAreaProvider = CustomStructureProperty.createProvider({
    label: 'Accessible Surface Area',
    descriptor: CustomPropertyDescriptor({
        name: 'molstar_accessible_surface_area',
        symbols: AccessibleSurfaceAreaSymbols,
        // TODO `cifExport`
    }),
    type: 'root',
    defaultParams: AccessibleSurfaceAreaParams,
    getParams: (data) => AccessibleSurfaceAreaParams,
    isApplicable: (data) => true,
    obtain: async (ctx, data, props) => {
        const p = { ...PD.getDefaultValues(AccessibleSurfaceAreaParams), ...props };
        return { value: await AccessibleSurfaceArea.compute(data, p).runInContext(ctx.runtime) };
    }
});
